import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";

sortSelectStyles.select = mergeToNew(sortSelectStyles.select, {
    labelProps: {
        size: 14,
        weight: 700,
        css: css`
            width: unset;
            padding: 4px 10px 0 0;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            flex-grow: 1;
            [class^="IconWrapper"] {
                top: 0px;
                right: 0px;
                width: 25px;
                height: 28px;
                padding: 0;
            }
        `,
        inputSelect: css`
            border-radius: 6px !important;
            height: 28px;
            font-size: 14px;
        `,
    },
});
